/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MaterialPositionTableComponent} from './material-position-table.component';
import {TooltipModule} from '../../../shared/tooltip/tooltip.module';
import {NgbDropdownModule, NgbTypeaheadModule} from '@ng-bootstrap/ng-bootstrap';
import {PipesModule} from '../../../shared/pipes/pipes.module';
import {WarningsModule} from '../../../shared/warnings/warnings.module';
import {MaterialPositionModalComponent} from '../material-position-modal/material-position-modal.component';
import {ReactiveFormsModule} from '@angular/forms';
import {ToggleButtonModule} from '../../../shared/toggle-button/toggle-button.module';
import {LoadingSpinnerModule} from '../../../shared/loading/loading-spinner/loading-spinner.module';
import {TableRowOverlayModule} from '../../../shared/table-row-overlay/table-row-overlay.module';
import {InputModule} from '../../../shared/input/input.module';
import {GenericOverlayModule} from '../../../shared/generic-overlay/generic-overlay.module';

@NgModule({
    declarations: [MaterialPositionTableComponent, MaterialPositionModalComponent],
    imports: [
        CommonModule,
        TooltipModule,
        NgbDropdownModule,
        PipesModule,
        WarningsModule,
        ReactiveFormsModule,
        NgbTypeaheadModule,
        ToggleButtonModule,
        LoadingSpinnerModule,
        TableRowOverlayModule,
        InputModule,
        GenericOverlayModule
    ],
    exports: [MaterialPositionTableComponent]
})
export class MaterialPositionTableModule {
}
